// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1aFO8","header":"ReportDetails_header__10puu","title":"ReportDetails_title__LFH5d","left":"ReportDetails_left__3HuK8"};